import React from "react";

import { Stack } from "@mui/material";
import { format } from "date-fns";

import { TradeProposalId } from "@fartherfinance/frontend/api/Investment/hooks/useRelatedTradeProposals";

import Text from "@src/sharedComponents/Typography/Text";
import displayTitleFromSecurity from "@src/utils/displayTitleFromSecurity";

import { LoadingDetailsRow } from "./LoadingErrorTrades";
import useSubmittedRelatedTrades from "./useSubmittedTrades.hooks";

import styles from "./RelatedTrades.module.css";

const RelatedTradesDetails = ({
  tradeProposalId,
  submittedAt,
}: {
  tradeProposalId: TradeProposalId;
  submittedAt?: Date;
}) => {
  const mergedTradeWithSecurity = useSubmittedRelatedTrades(
    tradeProposalId,
    submittedAt
  );

  if (mergedTradeWithSecurity.isLoading) {
    return <LoadingDetailsRow />;
  }

  if (mergedTradeWithSecurity.hasError) {
    return (
      <Stack padding={1} className={styles.tableRow}>
        <Text style={{ textAlign: "center" }} variant="body">
          Error loading related trades
        </Text>
      </Stack>
    );
  }

  // null check means the trade proposal is not submitted
  if (mergedTradeWithSecurity.data.trades === null) {
    return null;
  }

  return (
    <>
      {mergedTradeWithSecurity.data.trades.map((mergedTrade, i) => (
        <Stack
          key={i}
          direction={"row"}
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          className={styles.tableRow}
        >
          <Text variant="body" className={styles.textRow}>
            {format(
              mergedTradeWithSecurity.data.tradeProposal.createdAt,
              "M/d/yyyy"
            )}
          </Text>
          <Text variant="body" className={styles.textRow}>
            {mergedTrade.trade.custodianAccountId}
          </Text>
          <Text variant="body" className={styles.textRow}>
            {displayTitleFromSecurity(mergedTrade.security)}
          </Text>
          <Text variant="body" className={styles.textRow}>
            {mergedTrade.trade.side}
          </Text>
          <Text variant="body" className={styles.textRow}>
            {mergedTrade.trade.quantity.toNumber().toLocaleString("en-US")}
          </Text>
          <Text variant="body" className={styles.textRow}>
            {mergedTrade.trade.price.toNumber().toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </Text>
          <Text variant="body" className={styles.textRow}>
            {mergedTrade.trade.quantity
              .mul(mergedTrade.trade.price)
              .toNumber()
              .toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })}
          </Text>
        </Stack>
      ))}
    </>
  );
};

export default RelatedTradesDetails;
